import axios from "axios";
import { Collapse } from "bootstrap";

document.addEventListener('DOMContentLoaded', () => {
	const collectionFormButtonWrapper = document.getElementById('collection-form-button-wrapper');
	const collectionFormWrapper = document.getElementById('collection-form-wrapper');
	const collectionForm = document.getElementById('collection-form');

	if (!collectionFormButtonWrapper || !collectionFormWrapper || !collectionForm) return;

	collectionForm.addEventListener('submit', (event) => {
		event.preventDefault();

		const { action: url } = collectionForm;
		let data = new FormData(collectionForm);
		collectionForm.reset();

		axios.post(url, data, {
			responseType: 'json',
		}).then(function (response) {
			if (response.data.status) {
				return response;
			} else {
				let err = 'False status response';
				console.error(err);
				throw new Error(err);
			}
		}).then(function (response) {
			let collapse = new Collapse(collectionFormWrapper);
			collapse.hide();

			let button = collectionFormButtonWrapper.querySelector('button');
			let div = document.createElement('div');
			div.classList.add('text-white', 'bg-green', 'px-4', 'py-2');
			div.append('Спасибо! Ваш текст отправлен и будет показан после прохождения модерации.');

			collectionFormButtonWrapper.replaceChild(div, button);
		}).catch(function (error) {
			console.error(error.message);
			throw new Error(error.message);
		});
	});
}, { once: true });
